import { render, staticRenderFns } from "./B.vue?vue&type=template&id=2ddb2450&"
import script from "./B.vue?vue&type=script&lang=js&"
export * from "./B.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ddb2450')) {
      api.createRecord('2ddb2450', component.options)
    } else {
      api.reload('2ddb2450', component.options)
    }
    module.hot.accept("./B.vue?vue&type=template&id=2ddb2450&", function () {
      api.rerender('2ddb2450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/configurator/B.vue"
export default component.exports